import React from 'react';
import styled from '@emotion/styled';
import { PageHeader } from '../../shared/components';
import { PageLayout } from '../../shared/layout/page/PageLayout';
import { INewsPageData } from '../domain/models/INewsPageData';
import { HighlighedNewsStory } from './components/HighlightedNewsStory';
import { Sections } from '../../content-sections/ui';
import { PressReleasesSection } from './components/PressReleasesSection';
import { TheWindowSeatSection } from './components/TheWindowSeatSection';
import { OurLatestStoriesSection } from './components/OurLatestStoriesSection';
import { renderCustomExternalNewsCard } from '../helpers/renderCustomExternalNewsCard';
import { SocialMediaSection } from './components/social-media/SocialMediaSection';
import Responsive from '../../../ui/utils/Responsive';
import { NewsShortcutsSection } from './components/NewsShortcutsSection';
import { Section } from '../../content-sections/ui/components/Section';

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function NewsPage({
	page,
	highlighedNewsStory,
	recentNewsStories,
	pressReleases,
	recentBlogItems,
	socialMediaData,
}: INewsPageData) {
	return (
		<PageLayout showAlertsDialog page={page}>
			<PageHeader page={page}>
				{highlighedNewsStory && (
					<DesktopContainer>
						<HighlighedNewsStory highlighedNewsStory={highlighedNewsStory} />
					</DesktopContainer>
				)}
			</PageHeader>
			{highlighedNewsStory && (
				<MobileContainer>
					<HighlighedNewsStory highlighedNewsStory={highlighedNewsStory} />
				</MobileContainer>
			)}
			<NewsShortcutsSection />
			<OurLatestStoriesSection recentNewsStories={recentNewsStories} />
			<PressReleasesSection pressReleases={pressReleases} />
			<TheWindowSeatSection recentBlogItems={recentBlogItems} />
			<Sections
				render={renderCustomExternalNewsCard}
				sections={page.fields.sections ?? []}
			/>

			<SocialMediaSection
				youtubeVideoCollection={socialMediaData.youtubeCollection}
				socialMediaConfig={socialMediaData.config}
			/>
		</PageLayout>
	);
}

const DesktopContainer = styled(Section)`
	margin-bottom: 80px;
	padding: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: none;
	}
`;

const MobileContainer = styled(Section)`
	display: none;
	padding: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: block;
		margin-top: -50px;
		z-index: unset;
		position: relative;
	}
`;
